var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container not-found"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v(_vm._s(_vm.$t('not-found')))]),_c('a',{staticClass:"back btn btn-blue",staticStyle:{"display":"block"},attrs:{"href":"https://www.biconomy.com"}},[_vm._v(" "+_vm._s(_vm.$t('back'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }